/**
 * 全局弹窗管理器
 * 用于管理StoreCom等全局弹窗
 */

import { ref } from 'vue'

// 全局状态
const showStoreDialog = ref(false)
const storeDialogReason = ref('')

// 显示Store弹窗
export function openStoreDialog(reason: string = 'insufficient_balance') {
  storeDialogReason.value = reason
  showStoreDialog.value = true
}

// 关闭Store弹窗
export function closeStoreDialog() {
  showStoreDialog.value = false
  storeDialogReason.value = ''
}

// useStoreDialog composable
export function useStoreDialog() {
  return {
    showStoreDialog,
    storeDialogReason,
    openStoreDialog,
    closeStoreDialog
  }
}
